/**
 * useViewMode Hook
 *
 * Returns the current view mode based on the expert mode toggle.
 * 'easy' = default simplified view, 'expert' = full Workflow.tsx
 */

import { useExpertMode } from './useExpertMode';

export type ViewMode = 'easy' | 'expert';

export function useViewMode(): { mode: ViewMode } {
  const { expertMode } = useExpertMode();
  return { mode: expertMode ? 'expert' : 'easy' };
}
